export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar"])},
          "container_attach": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Archivo"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al contenedor"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "upload_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar"])},
          "click_to_upload": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para subir"])},
          "drag_and_drop_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" o arrastre y suelte el archivo"])},
          "close_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cerrar"])}
        }
      }
    }
  })
}